import React from 'react';
import { Linkedin, Mail, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Personal author bio card — drops at the bottom of blog posts.
 * People follow people, not companies. This card converts blog readers
 * into 1:1 followers (LinkedIn) and design-partner conversations.
 */
const AuthorBio = ({ post }) => (
  <div
    className="rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 p-6 sm:p-8"
    data-testid="blog-author-bio"
  >
    <div className="flex flex-col sm:flex-row gap-5 items-start">
      <img
        src="/images/founder.jpg"
        alt="Lakshmi Kiranmai Guduru"
        className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl object-cover ring-2 ring-emerald-500/30 flex-shrink-0"
      />
      <div className="flex-1">
        <p className="text-[11px] font-bold tracking-[0.2em] text-emerald-600 dark:text-emerald-400 mb-1.5">
          ABOUT THE AUTHOR
        </p>
        <h3 className="text-lg sm:text-xl font-bold text-slate-900 dark:text-white mb-1">
          Lakshmi Kiranmai Guduru
        </h3>
        <p className="text-sm text-slate-400 dark:text-slate-400 mb-3">
          Founder, CARTIEAI · Building in public
        </p>
        <p className="text-sm sm:text-[15px] text-slate-400 dark:text-slate-300 leading-relaxed mb-4">
          I'm building CARTIEAI to fix the cloud-cost problem I saw drain millions at companies I worked for — where engineering and finance kept talking past each other. If you liked this post, here's where I share unfiltered notes on building this in public:
        </p>
        <div className="flex flex-wrap gap-2">
          <a
            href="https://www.linkedin.com/in/lakshmi-kiranmai-guduru"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium bg-[#0A66C2] text-white hover:bg-[#004182] transition-colors"
            data-testid="author-bio-linkedin"
          >
            <Linkedin className="w-4 h-4" />
            Follow on LinkedIn
          </a>
          <a
            href="mailto:hello@cartieai.com"
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors"
            data-testid="author-bio-email"
          >
            <Mail className="w-4 h-4" />
            hello@cartieai.com
          </a>
          <Link
            to="/about"
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-emerald-600 dark:text-emerald-400 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 transition-colors"
            data-testid="author-bio-story"
          >
            Read my story
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default AuthorBio;
